import styled, { theme, css } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSetMainFilter } from '../../publicCatalogFiltersHooks';
import { useMenuStateContext } from './mobileCategoriesMenuStateContext';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import usageTracker from '../../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuOptionButton = styled(UIButton).withConfig({
  displayName: "MenuOption__MenuOptionButton",
  componentId: "sc-1cghqa8-0"
})(["width:100%;border-bottom:1px solid ", " !important;", ""], theme.colors.GREAT_WHITE, ({
  $isSubMenu
}) => $isSubMenu && css(["display:flex;justify-content:space-between;"]));
const MenuOption = ({
  filterName,
  optionName,
  isSubMenu = false,
  isAllOption = false
}) => {
  const {
    openSubMenu,
    closeMenuModal
  } = useMenuStateContext();
  const setMainFilter = useSetMainFilter();
  const handleOptionClick = () => {
    setMainFilter(filterName, optionName);
    closeMenuModal();
  };
  const handleSubMenuOptionClick = () => {
    // @ts-expect-error if isSubMenu is true, optionName is a SubMenuName
    openSubMenu(optionName);
    usageTracker.track('interaction', {
      action: 'open-mobile-catalog-categories-submenu',
      value: optionName
    });
  };
  const allOptionPrefix = isAllOption ? 'ALL_' : '';
  return /*#__PURE__*/_jsx("div", {
    role: "menuitem",
    children: /*#__PURE__*/_jsxs(MenuOptionButton, {
      $isSubMenu: isSubMenu,
      className: "p-x-5 p-y-3",
      onClick: isSubMenu ? handleSubMenuOptionClick : handleOptionClick,
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${filterName}.${allOptionPrefix}${optionName}`
      }), isSubMenu && /*#__PURE__*/_jsx(UIIcon, {
        color: theme.colors.SLINKY,
        name: "right",
        size: 18
      })]
    })
  });
};
export default MenuOption;